import CircularProgress from "@mui/material/CircularProgress";
import { FormattedMessage } from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon.js";
import SnackbarModal from "component/shared/snackbar";
import { Gender, Degree } from "constants/Defaults.js";
import SubscribeTextField from "./SubscribeTextField";
import SubscribeSelectField from "./SubscribeSelectField";
import SubscribeDateField from "./SubscribeDateField";
import SubscribePhoneField from "./SubscribePhoneField";
import SubscribePasswordField from "./SubscribePasswordField";

export default function RegisterForm({
  dir,
  currentLocale,
  control,
  register,
  errors,
  setError,
  clearErrors,
  onSubmit,
  buttonSpinner,
  showPassword,
  setShowPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  selectedPhoneCountry,
  setSelectedPhoneCountry,
  validateDobValue,
  countries,
  subscriptionTypes,
  snackbar,
}) {
  return (
    <form onSubmit={onSubmit}>
      <SubscribeSelectField
        register={register}
        name="registrationType"
        labelId="registration-type"
        dir={dir}
        currentLocale={currentLocale}
        options={subscriptionTypes}
        optionLabelKey="title"
        optionTranslationsKey="subscriptionTypeTranslations"
        labelTranslationId="title"
      />
      <br />

      <SubscribeTextField
        register={register}
        name="firstName"
        labelId="fname"
        error={errors?.firstName}
      />
      <SubscribeTextField
        register={register}
        name="lastName"
        labelId="lname"
        error={errors?.lastName}
      />
      <SubscribeSelectField
        register={register}
        name="gender"
        labelId="gender"
        dir={dir}
        currentLocale={currentLocale}
        options={Gender}
      />
      <SubscribeDateField
        control={control}
        error={errors?.dob}
        validateDobValue={validateDobValue}
      />
      <SubscribeSelectField
        register={register}
        name="degree"
        labelId="educational-qualification"
        dir={dir}
        currentLocale={currentLocale}
        options={Degree}
      />
      <br />

      <SubscribeTextField
        register={register}
        name="email"
        labelId="email"
        type="email"
        error={errors?.email}
      />

      {countries.length > 0 && (
        <SubscribeSelectField
          register={register}
          name="country"
          labelId="country"
          dir={dir}
          currentLocale={currentLocale}
          options={countries}
          optionTranslationsKey="countryTranslations"
        />
      )}
      {countries.length === 0 && (
        <div className="form-label row">
          <div className="col-xl-4 col-lg-3">
            <label>
              <FormattedMessage id="country" />:
            </label>
          </div>
        </div>
      )}

      <SubscribeTextField
        register={register}
        name="address"
        labelId="address"
        error={errors?.address}
      />
      <SubscribeTextField
        register={register}
        name="job"
        labelId="job"
        error={errors?.job}
      />
      <SubscribePhoneField
        control={control}
        errors={errors}
        selectedPhoneCountry={selectedPhoneCountry}
        setSelectedPhoneCountry={setSelectedPhoneCountry}
        setError={setError}
        clearErrors={clearErrors}
      />
      <SubscribeTextField
        register={register}
        name="username"
        labelId="username"
        error={errors?.username}
      />
      <SubscribePasswordField
        register={register}
        name="password"
        labelId="password"
        error={errors?.password}
        dir={dir}
        showPassword={showPassword}
        onToggle={() => setShowPassword(!showPassword)}
      />
      <SubscribePasswordField
        register={register}
        name="reenterPassword"
        labelId="reenter-password"
        error={errors?.reenterPassword}
        dir={dir}
        showPassword={showConfirmPassword}
        onToggle={() => setShowConfirmPassword(!showConfirmPassword)}
        className="form-label row mb-4"
      />

      <div className="text-center">
        <button
          type="submit"
          className="main-btn"
          style={{ marginInlineStart: "auto" }}
        >
          <span>
            {buttonSpinner ? (
              <span>
                <CircularProgress sx={{ color: "#fff" }} size={26} />
              </span>
            ) : (
              <>
                <span style={{ marginInlineEnd: "0.5rem" }}>
                  <FormattedMessage id="register" />
                </span>
                <ChevronIcon width={12} height={12} color="#FFFFFF" />
              </>
            )}
          </span>
        </button>
      </div>

      <SnackbarModal
        open={snackbar.open}
        onClose={snackbar.onClose}
        severity={snackbar.severity}
        message={snackbar.message}
      />
    </form>
  );
}
